import {
	// ApButtonDanger,
	ApButtonMain,
	ApButtonSecondary,
	ApIcon,
} from '@alixpartners/ui-components';

import React, { useContext, useEffect } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';

import { AllModules } from '@ag-grid-enterprise/all-modules';
import createDatasource from './ServerSideDatasource';
import {
	exportNormlizationCSV,
	updateDataClassificationState,
	updateNormilizationEditData,
	validateNormalizedFile,
} from 'utils/apiRequests';
import { Spinner } from 'components/LoadingIndicator/styles';
import {
	UploadTitle,
	UploadTitleDescription,
} from 'Data/OverwriteSpendCube/OverwriteSpendCube.styles';
import DownloadProgressbar from 'Data/DownloadData/DownloadProgressBar';
import { FileArchiveContext } from 'contexts/FileArchiveContext';
import { UploadStateContext } from 'contexts/UploadStateContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import { UploadVendorStateContext } from 'contexts/UploadVendorStateContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import {
	// BottomSection,
	Content,
	Description,
	Section,
	Sidebar,
	Title,
	Wrapper,
	TableWrapper,
	TabsWrapper,
} from './../VendorCleanup/VendorCleanup.styles';
import Dropzone from 'react-dropzone';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsContext } from 'contexts/SettingsContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import {
	getCurrencySymbolFromOptions,
	VENDOR_EDIT_SPEND_TYPE,
} from 'Data/utils';
import SidebarNavLink from 'Data/components/SidebarNavLink';
import { Route, Redirect, Switch } from 'react-router-dom';
import {
	NormalizationProvider,
	useNormalizationContext,
} from 'contexts/NormalizationContext/NormalizationProvider';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';
import { ETL_PROCESS_STATUS } from 'Data/constants';

const VendorEdit = ({ permissions, getStatus, normalizationUploadStatus }) => {
	const { currentRoute } = useNormalizationContext();
	const { currentState, isETL } = useContext(GenerateSpendCubeContext);
	const { currency } = useContext(QueryStringContext);
	const { hideDecimals } = useContext(SettingsContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const gridStyle = useMemo(
		() => ({
			height: '375px',
			width: '100%',
			marginLeft: '10px',
		}),
		[]
	);
	const [gridApi, setGridApi] = useState();
	const [isUploading, setIsUploading] = useState(false);
	const [editedRows, setEditedRows] = useState([]);
	const history = useHistory();
	const navigateTo = ({ url, id }) =>
		history.push(`/data/append/${currentRoute}`, { normalUrl: url, id: id });
	const defaultColDefs = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			editable: true,
		};
	}, []);
	const {
		NORMALIZATION_SUCCEEDED,
		CLASSIFICATION_IN_PROGRESS,
	} = ETL_PROCESS_STATUS;
	const [isSaving, setIsSaving] = useState(false);
	const gridRef = useRef();
	const [undos, setUndos] = useState([]);
	const [showDownloadNotification, setShowDownloadNotification] = useState(
		false
	);
	const [showUploadNotification, setShowUploadNotification] = useState(false);
	const [errorDownloadingCSV, setErrorDownloadingCSV] = useState('');
	const [isclassifierRunning, setClassifierRunning] = useState(false);
	const [showClassiferNotification, setShowClassifierNotification] = useState(
		false
	);
	const [errorClassifer, seterrorClassifer] = useState('');
	const [isPageDisabled, setIsPageDisbled] = useState(false);

	useEffect(
		() => {
			if (
				(currentState === NORMALIZATION_SUCCEEDED ||
					currentState === CLASSIFICATION_IN_PROGRESS) &&
				isETL === 1
			) {
				setIsPageDisbled(true);
			}
		}, //eslint-disable-next-line
		[currentState]
	);

	const [columnDefs] = useState([
		{
			headerName: 'Original Vendor Name',
			field: 'ORIGINAL_VENDOR_NAME',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'ORIGINAL_VENDOR_NAME',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Vendor Name',
			field: 'VENDOR_NAME',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'VENDOR_NAME',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Spend',
			field: 'PO_CURRENCY_BASE_VALUE',
			filterParams: {
				filterOptions: [
					'equals',
					'notEqual',
					'lessThan',
					'lessThanOrEqual',
					'greaterThan',
					'greaterThanOrEqual',
				],
			},
			colId: 'PO_CURRENCY_BASE_VALUE',
			filter: 'agNumberColumnFilter',
			sort: 'desc',
			valueFormatter: params => {
				return formatSpendWithDecimalAndSymbol(
					params.value,
					currencySymbol,
					hideDecimals,
					2
				).toUpperCase();
			},
		},
	]);
	const [gridOptions] = useState({
		modules: AllModules,
		columnDefs: columnDefs,
		cacheBlockSize: 200,
		maxBlocksInCache: 10,
		enableColResize: true,
		enableSorting: true,
		enableFilter: true,
		rowModelType: 'serverSide',

		floatingFilter: true,
		maxConcurrentDatasourceRequests: 1,
		multiSortKey: 'ctrl',
		enableRangeSelection: true,
		suppressCutToClipboard: true,
	});
	const updateObjectById = (id, newObject) => {
		setEditedRows(prevState => {
			const existingIndex = prevState.findIndex(obj => obj.ID === id);

			if (existingIndex !== -1) {
				const updatedState = [...prevState];
				updatedState[existingIndex] = newObject;
				return updatedState;
			} else {
				return [...prevState, newObject];
			}
		});
	};
	const handleCellValueChange = event => {
		const selectedRowNodes = gridApi.getSelectedNodes();
		if (
			event.oldValue &&
			event.newValue &&
			event.oldValue.toString() === event.newValue.toString() &&
			selectedRowNodes.length === 1
		) {
			return;
		}
		const modifiedRows = [];
		modifiedRows.push(event.data);
		updateObjectById(event.data.ID, event.data);
	};
	const onGridReady = useCallback(
		params => {
			setGridApi(params.api);

			gridRef.current.api.startEditingCell(params);
			const gridOptionsnew = {
				columnDefs,

				suppressRowClickSelection: true,
				...gridOptions,
			};
			const datasource = createDatasource(
				gridOptionsnew,
				params.columnApi,
				params.api
			);
			params.api.setServerSideDatasource(datasource);
		},
		[columnDefs, gridOptions]
	);
	const undo = shouldNotSave => {
		const lastActionData = undos.slice(-1)[0];
		const remainingUndos = undos.slice(0, -1);

		setUndos(remainingUndos);
		setDataToRows(lastActionData);
	};
	const setDataToRows = data => {
		if (gridApi) {
			data.forEach(rowData => {
				const rowNode = gridApi.getRowNode(rowData.ID);
				const flashColumns = [];

				Object.keys(rowNode.data).forEach(key => {
					if (rowNode.data[key] !== rowData[key]) {
						flashColumns.push(key);
					}
				});

				gridApi.flashCells({
					rowNodes: [rowNode],
					columns: flashColumns,
				});
				rowNode.setData(rowData);
			});
		}
	};
	const updateVendorNormilization = () => {
		const newmodifiedRows = editedRows.map(item => {
			const updatedItem = { ...item };
			delete updatedItem.PURCHASING_LOCATION_COUNTRY;
			delete updatedItem.PURCHASING_LOCATION_STATE;
			delete updatedItem.PURCHASING_LOCATION_REGION;
			delete updatedItem.RECEIVING_LOCATION;
			delete updatedItem.RECEIVING_LOCATION_STATE;
			delete updatedItem.RECEIVING_LOCATION_REGION;
			delete updatedItem.RECEIVING_LOCATION_COUNTRY;
			for (const prop in updatedItem) {
				if (updatedItem[prop] === '') {
					updatedItem[prop] = ' ';
				}
			}

			return updatedItem;
		});
		updateNormilizationEditData(newmodifiedRows)
			.then(() => {
				setIsSaving(state => !state);
			})
			.catch(error => {
				undo(true);
				setIsSaving(state => !state);

				if (error.response && error.response.status === 400) {
					console.log('Error');
					setErrorDownloadingCSV(error.response);
				}
			});
		setIsSaving(state => !state);
	};
	const handleCloseNotification = () => {
		setShowDownloadNotification(false);
	};
	const handleCloseClassfierNotification = () => {
		setShowClassifierNotification(false);
	};

	const handleTriggerPipeline = () => {
		setShowClassifierNotification(true);
		setTimeout(() => {
			setShowClassifierNotification(false);
		}, 2000);
		setClassifierRunning(true);
		updateDataClassificationState(1)
			.then(response => {
				getStatus();
				setClassifierRunning(false);
				updateDataClassificationState(0)
					.then(() => {
						getStatus();
					})
					.then(() => {
						const pattern = /\/([^/]+)\.csv/;
						const match = response.fileName.match(pattern);
						navigateTo({ url: response.fileName, id: match[1] });
					});
			})
			.catch(error => {
				seterrorClassifer(error.response);
				updateDataClassificationState(0);
				getStatus();
				setClassifierRunning(false);
			});
	};
	const handleRunClassiferDisable = () => {
		if (normalizationUploadStatus === 0) {
			return false;
		} else {
			return true;
		}
	};
	const onFileSelected = acceptedFiles => {
		setShowUploadNotification(true);
		setIsUploading(true);
		const file = acceptedFiles[0];
		validateNormalizedFile(file).then(() => setIsUploading(false));
	};

	const showRoute = useMemo(
		() =>
			VENDOR_EDIT_SPEND_TYPE.find(({ required, name }) => {
				return permissions.includes(required) && name === currentRoute;
			}),
		[currentRoute, permissions]
	);

	return (
		<Wrapper>
			<Sidebar>
				<Section>
					<Title>Data upload</Title>
					<Description>
						<p>Data upload process:</p>
						<p>1. Upload file into the system</p>
						<p>2. Configure set up</p>
						<p>3. Cleanup vendor names</p>
					</Description>
				</Section>
				<TabsWrapper>
					{VENDOR_EDIT_SPEND_TYPE.map(({ label, path, required, name }) => {
						if (required && !permissions.includes(required)) {
							return null;
						}

						return (
							<SidebarNavLink
								key={path}
								to={path}
								iconName="cloud_upload"
								disabled={name !== currentRoute}
							>
								{label}
							</SidebarNavLink>
						);
					})}
				</TabsWrapper>
			</Sidebar>
			<Content>
				<Switch>
					{VENDOR_EDIT_SPEND_TYPE.map(({ path, required }) => {
						if (!permissions.includes(required)) {
							return null;
						}
						return (
							<Route
								key={path}
								path={path}
								render={() => (
									<div style={{ width: '100%' }}>
										<div style={{ display: 'flex' }}>
											<div
												style={{
													margin: '15px',
													marginLeft: '10px',
													marginTop: 0,
												}}
											>
												<UploadTitle>
													Output for Vendor Normalization
												</UploadTitle>
												{!isPageDisabled && (
													<UploadTitleDescription>
														Below Data can be edited and we can run Classifier
														on it.
													</UploadTitleDescription>
												)}
											</div>
											{!isPageDisabled && (
												<ApButtonMain
													style={{ marginLeft: 'auto' }}
													iconName="outline_save_alt"
													onClick={() => {
														setShowDownloadNotification(true);
														exportNormlizationCSV().then(
															setShowDownloadNotification(true)
														);
													}}
													disabled={isPageDisabled}
												>
													Download
												</ApButtonMain>
											)}
											&nbsp; &nbsp;
											<Dropzone
												onDrop={onFileSelected}
												style={{ marginLeft: '5px' }}
												noKeyboard
											>
												{({ getRootProps, getInputProps }) => (
													<div {...getRootProps()}>
														<input {...getInputProps()} accept=".csv" />
														{!isPageDisabled && (
															<ApButtonSecondary
																style={{ marginLeft: 'auto' }}
																iconName={!isUploading && 'upload_outlined'}
																disabled={isPageDisabled}
															>
																{isUploading && (
																	<Spinner
																		size={22}
																		thickness={3}
																		color="green"
																	/>
																)}&nbsp; Upload
															</ApButtonSecondary>
														)}
													</div>
												)}
											</Dropzone>
										</div>
										<TableWrapper>
											<div style={gridStyle} className="ag-theme-balham">
												<AgGridReact
													ref={gridRef}
													modules={AllModules}
													columnDefs={columnDefs}
													cacheBlockSize={200}
													defaultColDef={defaultColDefs}
													maxBlocksInCache={10}
													enableColResize={true}
													enableSorting={true}
													enableFilter={true}
													enableGroupEdit={true}
													rowModelType="serverSide"
													maxConcurrentDatasourceRequests={1}
													multiSortKey="ctrl"
													onCellValueChanged={handleCellValueChange}
													onGridReady={onGridReady}
													enableRangeSelection={true}
													suppressCutToClipboard={true}
												/>
											</div>
										</TableWrapper>
										<ApSignalrConsumer
											message={['DataUploading']}
											onMessage={() => getStatus()}
										/>
										<ApSignalrConsumer
											message={['ClassifierRunning']}
											onMessage={() => getStatus()}
										/>
										<ApSignalrConsumer
											message={['NormalizationFileUploadFalied']}
											onMessage={() => getStatus()}
										/>
										<ApSignalrConsumer
											message={['Normalization completed']}
											onMessage={() => {
												if ('isautomation') {
													handleTriggerPipeline();
												}
											}}
										/>
										{showDownloadNotification && (
											<DownloadProgressbar
												error={errorDownloadingCSV}
												failMessage="Error generating file"
												successMessage="Generating file... You will receive a notification when the file has been generated"
												onClose={() => handleCloseNotification()}
											/>
										)}
										{showUploadNotification && (
											<DownloadProgressbar
												error={errorDownloadingCSV}
												failMessage="Error generating file"
												successMessage="Data Uploading in Progress...You will receive a notification when upload is complete"
												onClose={() => setShowUploadNotification(false)}
											/>
										)}
										{showClassiferNotification && (
											<DownloadProgressbar
												error={errorClassifer}
												failMessage="Error Running Classifier"
												successMessage="Data Transfering"
												onClose={() => handleCloseClassfierNotification()}
											/>
										)}
										<div
											style={{
												display: 'flex',
												justifyContent: 'space-between',
											}}
										>
											<span />
											{!isPageDisabled && (
												<div
													style={{
														display: 'flex',
														margin: '10px',
														marginRight: '-10px',
													}}
												>
													<div>
														<ApButtonSecondary
															style={{ marginRight: '10px' }}
															onClick={() => updateVendorNormilization()}
															disabled={isPageDisabled}
														>
															{isSaving ? (
																<Spinner size={24} thickness={3} />
															) : (
																<ApIcon
																	iconName="save"
																	material={true}
																	iconColor="black"
																/>
															)}
															&nbsp; Save
														</ApButtonSecondary>
													</div>
													<div>
														<ApButtonMain
															onClick={() => handleTriggerPipeline()}
															disabled={
																handleRunClassiferDisable() || isPageDisabled
															}
														>
															{isclassifierRunning && (
																<Spinner
																	size={24}
																	thickness={3}
																	color="white"
																/>
															)}
															&nbsp; Run Classifier
														</ApButtonMain>
													</div>
												</div>
											)}
										</div>
									</div>
								)}
							/>
						);
					})}
					{showRoute && <Redirect to={showRoute.path} />}
				</Switch>
			</Content>
		</Wrapper>
	);
};

export default props => (
	<NormalizationProvider>
		<FileArchiveContext.Consumer>
			{({ fileArchive }) => (
				<UploadVendorStateContext.Consumer>
					{({ vendorStatus }) => (
						<UploadStateContext.Consumer>
							{({ status, normalizationUploadStatus, refetch }) => (
								<PermissionsContext.Consumer>
									{({ permissions }) => (
										<VendorEdit
											{...props}
											vendorStatus={vendorStatus}
											permissions={permissions || []}
											status={status}
											normalizationUploadStatus={normalizationUploadStatus}
											getStatus={refetch}
											fileArchive={fileArchive}
										/>
									)}
								</PermissionsContext.Consumer>
							)}
						</UploadStateContext.Consumer>
					)}
				</UploadVendorStateContext.Consumer>
			)}
		</FileArchiveContext.Consumer>
	</NormalizationProvider>
);
